import LoadingDots from 'components/LoadingDots';
import NavigationableLayout, {
  NavigationableLayoutProps,
} from 'modules/app/components/NavigationableLayout';
import React, { ComponentType } from 'react';
import { Redirect } from 'react-router-dom';
import Section from 'reusable-components/layout/Section';
import { useUser } from '~/authentication/store';

type PrivateHostRouteProps = {
  component: ComponentType;
} & NavigationableLayoutProps;

function PrivateHostRoute({
  component: Component,
  ...props
}: PrivateHostRouteProps) {
  const {
    isHost,
    isOnboardingHost,
    isOnboardingHostWebinar,
    loading,
    isLoggedIn,
  } = useUser();

  if (loading) {
    return (
      <Section as="main" noSpace="all" variant="sandstone-light">
        <LoadingDots />
      </Section>
    );
  }

  if (!loading && !isLoggedIn) {
    return <Redirect to="/" />;
  }

  if (!isHost && !isOnboardingHost && !isOnboardingHostWebinar) {
    return <Redirect to="/" />;
  }

  return <NavigationableLayout component={Component} {...props} />;
}

export default PrivateHostRoute;
